export default {
  "hierarchy": {
    "mobileItemScreen": [
      "breadcrumbs-mobileItemScreen"
    ],
    "topNavBreadcrumbs": [
      "breadcrumbs-topNavBreadcrumbs"
    ],
    "mobileTopNavBreadcrumbs": [
      "breadcrumbs-topNavBreadcrumbs",
      "breadcrumbs-mobileTopNavBreadcrumbs"
    ]
  },
  "props": {
    "default": {
      "separator": "|",
      "separatorIcon": "lv lv-chevronRight "
    },
    "mobileItemScreen": {
      "separator": " ",
      "separatorIcon": "lv lv-chevronRight "
    },
    "topNavBreadcrumbs": {
      "separator": "|",
      "separatorIcon": "fa fa-chevron-right"
    },
    "mobileTopNavBreadcrumbs": {
      "separator": "|",
      "separatorIcon": "fa fa-chevron-right"
    }
  }
}